import {
  HomepageNavigationIntent,
  type ResolveHomepageNavigationIntentFn,
} from "@capone/common";
import {
  PATH_CORE_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_CORE_PACKAGES_HOTEL_AVAILABILITY,
  PATH_CUSTOMER_PROFILE,
  PATH_FLIGHTS_SHOP,
  PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY,
  PATH_HOTELS_FLIGHTS_SEARCH,
  PATH_PACKAGES_HOTEL_AVAILABILITY,
  PATH_PACKAGES_SEARCH,
  PATH_TRAVEL_WALLET,
} from "../../utils/urlPaths";

const TRAVEL_OFFERS_FAQ_HASH = "#faq";

type HomepageNavigationResolverOptions = {
  isCorporateTenant: boolean;
  showCorePackages: boolean;
};

const getPackagesSearchPath = (isCorporateTenant: boolean) =>
  isCorporateTenant ? PATH_HOTELS_FLIGHTS_SEARCH : PATH_PACKAGES_SEARCH;

const getPackagesAvailabilityPath = (
  isCorporateTenant: boolean,
  showCorePackages: boolean
) => {
  if (isCorporateTenant) {
    return showCorePackages
      ? PATH_CORE_HOTELS_FLIGHTS_HOTEL_AVAILABILITY
      : PATH_HOTELS_FLIGHTS_HOTEL_AVAILABILITY;
  }
  return showCorePackages
    ? PATH_CORE_PACKAGES_HOTEL_AVAILABILITY
    : PATH_PACKAGES_HOTEL_AVAILABILITY;
};

export const createHomepageNavigationResolver =
  ({
    isCorporateTenant,
    showCorePackages,
  }: HomepageNavigationResolverOptions): ResolveHomepageNavigationIntentFn =>
  (intent: string) => {
    switch (intent) {
      case HomepageNavigationIntent.TravelOffersActivity:
        return PATH_TRAVEL_WALLET;
      case HomepageNavigationIntent.TravelOffersFaq:
        return `${PATH_TRAVEL_WALLET}${TRAVEL_OFFERS_FAQ_HASH}`;
      case HomepageNavigationIntent.FlightsShopDeparture:
        return PATH_FLIGHTS_SHOP;
      case HomepageNavigationIntent.PackagesSearch:
        return getPackagesSearchPath(isCorporateTenant);
      case HomepageNavigationIntent.PackagesHotelsAvailability:
        return getPackagesAvailabilityPath(isCorporateTenant, showCorePackages);
      case HomepageNavigationIntent.TravelProfileTravelers:
        return `${PATH_CUSTOMER_PROFILE}?section=travelers`;
      default:
        return undefined;
    }
  };
